import React from 'react';
import { CheckSquare, Sofa, PencilRuler, Wrench, HardHat, Calculator } from 'lucide-react';

const AdditionalOptionsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <CheckSquare className="w-5 h-5 mr-2 text-green-500" />
        Дополнительные услуги
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Включение визуализации */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeVisualization"
              checked={formData.includeVisualization}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <Calculator className="w-4 h-4 text-green-500 mr-1" />
              Включить визуализацию
            </span>
          </label>
        </div>

        {/* Дизайн интерьера */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeInteriorDesign"
              checked={formData.includeInteriorDesign}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <Sofa className="w-4 h-4 text-green-500 mr-1" />
              Дизайн интерьера
            </span>
          </label>
        </div>

        {/* Инженерные системы */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeEngineeringSystems"
              checked={formData.includeEngineeringSystems}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <Wrench className="w-4 h-4 text-green-500 mr-1" />
              Проектирование инженерных систем
            </span>
          </label>
        </div>

        {/* Строительная документация */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeConstructionDocumentation"
              checked={formData.includeConstructionDocumentation}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <PencilRuler className="w-4 h-4 text-green-500 mr-1" />
              Строительная документация
            </span>
          </label>
        </div>

        {/* Авторский надзор */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeProjectSupervision"
              checked={formData.includeProjectSupervision}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <HardHat className="w-4 h-4 text-green-500 mr-1" />
              Авторский надзор
            </span>
          </label>
        </div>
      </div>

      <div className="mt-4 bg-green-100 dark:bg-green-900/30 p-3 rounded-lg border border-green-200 dark:border-green-800">
        <div className="flex items-start">
          <CheckSquare className="w-5 h-5 text-green-600 dark:text-green-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-1">
              Дополнительные услуги
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400">
              Дополнительные услуги позволяют получить комплексный подход к проектированию. 
              Дизайн интерьера включает планировку помещений и подбор материалов. 
              Инженерные системы охватывают проектирование отопления, вентиляции, электроснабжения и водоснабжения. 
              Авторский надзор обеспечивает контроль соответствия строительства проектной документации.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalOptionsSection;